import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

const SpecialtyCardSlider = () => {
  const { t } = useTranslation();

  const specialties = [
    {
      icon: "/assets/images/HomePage/Logo-sante/pediatrie.svg",
      label: t("HomePage.section2.Pédiatrie"),
      bgColor: "bg-pink",
      glowEffect: "pulse-glow",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/cardiologie.svg",
      label: t("HomePage.section2.Cardiologie"),
      bgColor: "bg-red",
      glowEffect: "pulse-glow-red",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/physchiatrie.svg",
      label: t("HomePage.section2.Physchiatrie"),
      bgColor: "bg-green",
      glowEffect: "pulse-glow-green",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/urologie.svg",
      label: t("HomePage.section2.Urologie"),
      bgColor: "bg-dark-yellow",
      glowEffect: "pulse-glow-yellow",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/ophtalmologie.svg",
      label: t("HomePage.section2.Ophtalmologie"),
      bgColor: "bg-blue-primary",
      glowEffect: "pulse-glow-blue",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/estomac.svg",
      label: t("HomePage.section2.Gastro-entérologie"),
      bgColor: "bg-[#C17E77]",
      glowEffect: "pulse-glow-brown",
    },
    {
      icon: "/assets/images/HomePage/Logo-sante/infection.svg",
      label: t("HomePage.section2.Et plus"),
      bgColor: "bg-red",
      glowEffect: "pulse-glow-red",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: false, // Désactiver l'arrêt sur survol
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="w-full overflow-hidden px-4">
      <Slider {...settings} className="h-full">
        {specialties.map((specialty, index) => (
          <div key={index} className="h-full gap-4">
            <div
              className={`h-full ${specialty.bgColor} w-[80%] max-w-[300px] mx-auto rounded-2xl shadow-md shadow-gray-400 
                flex px-8 flex-col items-start justify-center py-6 ${specialty.glowEffect}`}
              style={{ transform: "translate3d(0, 0, 0)" }}
            >
              <div className="flex mb-2">
                <img
                  src={specialty.icon}
                  alt={specialty.label}
                  className="h-20"
                />
              </div>
              <p className="text-white text-lg font-semibold">
                {specialty.label}
              </p>
              <span className="w-full h-[2px] bg-white mt-2"></span>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SpecialtyCardSlider;
